<template>
  <Icon :component="HistorySvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import HistorySvg from './svg/HistorySvg.vue';

export default defineComponent({
  name: 'HistoryIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      HistorySvg: markRaw(HistorySvg)
    };
  }
});
</script>
